import { GetterTree } from "vuex";
import { AgenceState, AgenceGetters, AgenceStorage } from "./interface";
import { AgenceGettersTypes } from "./types";

export const getters: GetterTree<AgenceState, AgenceState> & AgenceGetters = {
  [AgenceGettersTypes.AGENCE_ALL_ID]: (state: AgenceState): Array<string> => {
    return state.AgenceAllId;
  },
  [AgenceGettersTypes.AGENCE_BY_ID]: (state: AgenceState): AgenceStorage => {
    return state.AgenceById;
  }
};
